<template>
  <div class="c-collapseSubCategories">
    <ul class="c-collapseSubCategories_list">
      <li>
        <NuxtLink
          class="c-collapseSubCategories_item"
          :to="`/categories/${category.id}?ref=splist`"
        >
          すべて
        </NuxtLink>
      </li>
      <li v-if="isFortuneCategory">
        <NuxtLink
          class="c-collapseSubCategories_item"
          :to="`/categories/${category.id}?service_kind=1&ref=splist`"
        >
          電話占い
        </NuxtLink>
      </li>
      <li
        v-for="subCategory in category.subCategories"
        :key="subCategory.id"
      >
        <NuxtLink
          class="c-collapseSubCategories_item"
          :to="`/categories/${subCategory.id}?ref=splist`"
        >
          {{ subCategory.name }}
        </NuxtLink>
      </li>
      <!-- 関連カテゴリのリンクを表示 -->
      <li
        v-for="relatedCategory in relatedCategories"
        :key="`relatedCategory${relatedCategory.id}`"
      >
        <NuxtLink
          class="c-collapseSubCategories_item"
          :to="`/categories/${relatedCategory.id}?ref=splist`"
        >
          {{ relatedCategory.name }}
        </NuxtLink>
      </li>
      <li v-if="category.id === agentAndLegalCategoryId">
        <a
          :href="legalUrl"
          class="c-collapseSubCategories_item"
          target="_blank"
          rel="noopener"
        >
          法律相談・弁護士検索
          <CoconalaIcon
            name="external-link"
            size="12px"
            color="ds2Gray600"
          />
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import SubCategoriesMixin from '@/mixins/category/sub-categories-mixin'

// vuex
import { mapState, mapGetters } from 'vuex'

/** @type {import('vue').ComponentOptions} */
const collapseSubCategories = {
  name: 'CollapseSubCategories',
  mixins: [SubCategoriesMixin],
  props: {
    category: {
      type: Object,
      required: true
    },
    isBusiness: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('master', ['agentAndLegalCategoryId']),
    ...mapGetters('constants', ['getRelatedCategories']),
    ...mapGetters('ui', ['isPC']),
    relatedCategories() {
      return this.getRelatedCategories(this.category.id)
    },
    legalUrl() {
      return this.$coconala.legalUrl('menu', this.isPC, this.isBusiness)
    }
  }
}
export default collapseSubCategories
</script>
<style lang="scss" scoped>
.c-collapseSubCategories {
  &_list {
    display: flex;
    flex-direction: column;
  }

  &_item {
    display: flex;
    padding: 8px 36px 8px 56px;
    color: $ds2-color-gray-900;
    font-size: 14px;
    line-height: 1.5;

    align-items: center;
    justify-content: space-between;
  }
}
</style>
